export const FlexClasses = {
    FLEX_ROW: ['wf-flex-row'],
    FLEX_COL: ['wf-flex-col']
}

export const FlexWrapClasses = {
    FLEX_WRAP: ['wf-flex-wrap'],
    FLEX_NO_WRAP: ['wf-flex-no-wrap']
}

export const JustifyContentClasses = {
  JUSTIFY_START: ['wf-justify-start'],
  JUSTIFY_CENTER: ['wf-justify-center'],
  JUSTIFY_BETWEEN: ['wf-justify-between']
}

export const AlignContentClasses = {
  CONTENT_START: ['wf-content-start'],
  CONTENT_CENTER: ['wf-content-center'],
  CONTENT_END: ['wf-content-end']
}

export const AlignItemsClasses = {
  ALIGN_ITEMS_CENTER: ['wf-items-center']
}

export const FlexSizeClasses = {
  FLEX_INITIAL: ['wf-flex-initial'],
  FLEX_ONE: ['wf-flex-1'],
  FLEX_AUTO: ['wf-flex-auto'],
  FLEX_NONE: ['wf-flex-none']
}
